import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AuthRedirectGuard implements CanActivate {

  constructor(private router: Router) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    const currentUrl = state.url;  // obtengo la url de donde estoy
    const redirectUrl = this.getRedirectUrl();

    // una verificacion para evitar loops infinitos
    if (redirectUrl && currentUrl !== redirectUrl) {
      this.router.navigate([redirectUrl]);
      return false;  // regreso false para evaluar que no se active la ruta pues estoy donde mismo
    }

    return true;  // regreso true para evaluar que se active la ruta
  }

  private getRedirectUrl(): string | null {
    // para redireccionar dependiendo de la variable de ambiente
    switch (environment.Ambiente.toLowerCase()) {
      //ambiente factor
      case 'ProdFactoraje'.toLowerCase():
        return '/login';
      case 'TestFactoraje'.toLowerCase():
        return '/login';
      case 'TestFactorajeAU'.toLowerCase():
        return '/login';
      case 'ProdFactorajeAU'.toLowerCase():
        return '/login';
      //ambiente ventus
      case 'ventusTest'.toLowerCase():
        return '/loginven';
      case 'ventusProd'.toLowerCase():
        return '/loginven';
      // ambiente flieben capital
      case 'fliebencaptest'.toLocaleLowerCase():
        return '/loginfbcap';
      case 'fliebencapprod'.toLocaleLowerCase():
        return '/loginfbcap';
      // ambiente flieben3
      case 'fliebentrestest'.toLocaleLowerCase():
        return '/loginfbtres';
      case 'fliebentresprod'.toLocaleLowerCase():
        return '/loginfbtres';
            // ambiente factea
      case 'TestFactea'.toLocaleLowerCase():
        return '/loginfactea';
      case 'ProdFactea'.toLocaleLowerCase():
        return '/loginfactea';
      default:
        return null;  // no redirigir a ningun lado y puedo entrar a todo
    }
  }
}